var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInActiveAppicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 21034"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17 9H12",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M9 2H15.5C15.9644 2 16.1966 2 16.3916 2.02567C17.7378 2.2029 18.7971 3.26222 18.9743 4.60842C19 4.80337 19 5.03558 19 5.5",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M1 5.94975C1 5.06722 1 4.62595 1.06935 4.25839C1.37464 2.64031 2.64031 1.37464 4.25839 1.06935C4.62595 1 5.06722 1 5.94975 1C6.33642 1 6.52976 1 6.71557 1.01738C7.51665 1.09229 8.27652 1.40704 8.89594 1.92051C9.0396 2.03961 9.1763 2.17633 9.4497 2.44975L10 3C10.8158 3.81578 11.2237 4.22367 11.7121 4.49543C11.9804 4.64471 12.2651 4.7626 12.5604 4.84678C13.0979 5 13.6747 5 14.8284 5H15.2021C17.8345 5 19.1506 5 20.0062 5.76946C20.0849 5.84024 20.1598 5.91514 20.2305 5.99383C21 6.84935 21 8.16554 21 10.7979V13C21 16.7712 21 18.6569 19.8284 19.8284C18.6569 21 16.7712 21 13 21H9C5.22876 21 3.34315 21 2.17157 19.8284C1 18.6569 1 16.7712 1 13V5.94975Z",
    stroke: "white",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInActiveAppicon);
export default __webpack_public_path__ + "static/media/inActive-appicon.9be26e67485ae64c4b225baf59de8d05.svg";
export { ForwardRef as ReactComponent };